import { Inject, Injectable } from '@angular/core';
import { RestService } from '../../../../../core/services/rest.service';
import { GrdfAccessRightStatus } from '../../grdf.models';

export interface GrdfConsent {
    clientName: string;
    clientRepresentativeName: string;
    clientRepresentativeEmail: string;
    clientSirenSiret: string;
    pdlNumber: string;
    consumptionAccessStart: Date;
    validUntil: Date;
    organization: string;
    status: GrdfAccessRightStatus;
    grdfClientName: string;
    consentStart: string;
}

export interface GrdfConsentStatus {
    status: GrdfAccessRightStatus;
    consentStart: string;
}

@Injectable({
    providedIn: 'root',
})
export class GrdfConsentService {
    constructor(@Inject(RestService) private restService: RestService) {}

    public async getEnedisConsentStatus(token: string): Promise<GrdfConsentStatus> {
        try {
            const path = `/grdf/consent?token=${token}`;
            const result = await this.restService.get(path, {});
            return result as GrdfConsentStatus;
        } catch (err) {
            console.error('Error getting grdf consent status', err);
            throw err;
        }
    }

    public async updateConsent(
        token: string,
        status: GrdfAccessRightStatus,
    ): Promise<GrdfConsentStatus> {
        try {
            const path = `/grdf/consent`;
            const result = await this.restService.patch(path, {}, { token: token, status: status });
            return result as GrdfConsentStatus;
        } catch (err) {
            console.error('Error updating grdf consent', err);
            throw err;
        }
    }
}
